// Registries: id → definition maps built from the content lists.
import { CHARM_LIST } from './charms';
import { COLLECTOR_LIST } from './collectors';
import type { CharmDef, CollectorDef, DealDef, HexDef, NodeDef, PatternDef, RelicDef, SymbolDef } from './defs';
import { HEX_LIST } from './hexes';
import { LEDGER_PAGES } from './ledger';
import { NODE_LIST } from './nodes';
import { PATTERN_LIST } from './patterns';
import { DEAL_LIST } from './propositions';
import { RELIC_LIST } from './relics';
import { SYMBOL_LIST } from './symbols';
import { buildAdjacency } from './webLayout';
import type { PatternId } from '../sim/types';

function toMap<T extends { id: string }>(list: T[]): Map<string, T> {
  return new Map(list.map((d) => [d.id, d]));
}

export const SYMBOLS: ReadonlyMap<string, SymbolDef> = toMap(SYMBOL_LIST);
export const CHARMS: ReadonlyMap<string, CharmDef> = toMap(CHARM_LIST);
export const NODES: ReadonlyMap<string, NodeDef> = toMap(NODE_LIST);
export const PATTERNS: ReadonlyMap<PatternId, PatternDef> = new Map(PATTERN_LIST.map((p) => [p.id, p]));
export const COLLECTORS: ReadonlyMap<string, CollectorDef> = toMap(COLLECTOR_LIST);
export const HEXES: ReadonlyMap<string, HexDef> = toMap(HEX_LIST);
export const DEALS: ReadonlyMap<string, DealDef> = toMap(DEAL_LIST);
export const RELICS: ReadonlyMap<string, RelicDef> = toMap(RELIC_LIST);
export const WEB_ADJ = buildAdjacency();

export function symbolDef(id: string): SymbolDef {
  const d = SYMBOLS.get(id);
  if (!d) throw new Error(`unknown symbol ${id}`);
  return d;
}

export { CHARM_LIST, COLLECTOR_LIST, DEAL_LIST, HEX_LIST, LEDGER_PAGES, NODE_LIST, PATTERN_LIST, RELIC_LIST, SYMBOL_LIST };
